import {Action, getModule, Module, Mutation, VuexModule} from 'vuex-module-decorators'
import store from '@/store'
import CompanyLocation from "@/model/CompanyLocation";
import ActiveModule from './ActiveModule';
import {Inject} from "typescript-ioc";
import {LocalStorageWrapper} from "@/storage/StorageWrapper";
import StorageKey from "@/storage/StorageKey";

export abstract class CompanyLocationModule implements ActiveModule<CompanyLocation> {
    abstract active: CompanyLocation;
    abstract activeOrNull: CompanyLocation | null;

    abstract activate(t: CompanyLocation): Promise<void>;

    abstract hasActive(): Promise<boolean>;

    abstract inactivate(): Promise<void>;

    abstract destroy(): Promise<void>
}

@Module({dynamic: true, namespaced: true, store, name: 'companyLocation'})
class CompanyLocationModuleImpl extends VuexModule implements CompanyLocationModule {

    @Inject
    private storage!: LocalStorageWrapper

    private key = StorageKey.COMPANY_LOCATION

    activeOrNull: CompanyLocation | null = this.storage.getOrNull<CompanyLocation>(this.key)

    get active(): CompanyLocation {
        return this.activeOrNull ?? new CompanyLocation()
    }

    @Action
    async activate(t: CompanyLocation): Promise<void> {
        this.set(t)
        this.storage.set(this.key, t)
    }

    @Action
    async inactivate(): Promise<void> {
        this.remove()
        this.storage.remove(this.key)
    }

    @Action
    async hasActive(): Promise<boolean> {
        return this.activeOrNull != null
    }

    @Action
    async destroy(): Promise<void> {
        this.inactivate()
    }

    @Mutation
    private set(t: CompanyLocation) {
        this.activeOrNull = t
    }

    @Mutation
    private remove() {
        this.activeOrNull = null
    }
}

const companyLocationModule: CompanyLocationModule = getModule(CompanyLocationModuleImpl)
export default companyLocationModule
